import { defaultColors, LegendItem } from '@toggle/chart';
import React from 'react';

import { Entity } from '~/api/entities/entity-schema';

import * as S from './Legend.styles';

export interface LegendProps {
  activeAssets: Entity[];
}

export const Legend = ({ activeAssets }: LegendProps) => {
  const colorArray = Object.values(defaultColors.multi);

  return (
    <S.LegendRoot data-testid="legend">
      <S.LegendContainer>
        {activeAssets.map((asset, i) => (
          <LegendItem
            key={i}
            logoUrl={asset.logo_url}
            ticker={asset.ticker}
            resample={'1D'}
            exchange={asset.exchange.code}
            price={'939.00 '}
            priceChange={'+5.00 (+1.00%)'}
            name={asset.name_short}
            isPrimary={i === 0}
            legendColor={
              colorArray[i] && i !== 0
                ? colorArray[i]
                : defaultColors.line.default
            }
          />
        ))}
      </S.LegendContainer>
    </S.LegendRoot>
  );
};
